import React from 'react';
import { Tabs } from 'crm/_components/';
import { staticStyles } from './style';
import CRMDepositsTab from './CRMDepositsTab';
import CRMWithdrawalsTab from './CRMWithdrawalsTab';
import CRMTransfersTab from './CRMTransfersTab';

// Wrapper component to avoid passing tabSlug/tabTextId to DOM
// eslint-disable-next-line no-unused-vars
const TabWrapper = ({ children, tabSlug, tabTextId }) => <>{children}</>;

const FinancesPage = () => (
  <div className="FinancesPage">
    <Tabs externalClass="FinancesPage__tabs">
      <TabWrapper tabTextId="justDeposit" tabSlug="deposits">
        <CRMDepositsTab />
      </TabWrapper>
      <TabWrapper tabTextId="justWithdraw" tabSlug="withdraws">
        <CRMWithdrawalsTab />
      </TabWrapper>
      <TabWrapper tabTextId="crmInternalTransfers" tabSlug="internalTransfers">
        <CRMTransfersTab />
      </TabWrapper>
    </Tabs>
    <style jsx global>
      {staticStyles}
    </style>
  </div>
);

export default FinancesPage;
